export default "__VITE_ASSET__CEl1C3hV__"